import React from 'react'
import {useStore} from 'react-hookstore'
import {labeledText as lt} from './labeledText.js'

export default function GetLabeledText (props) {
  const [lang] = useStore('language')
  let label = props.children
  let textNode = <div className='msg' dangerouslySetInnerHTML={{__html: lt[label][lang+2]}}/>
  return (
  <div className='labeledtext'>
    <div className='labeled'>{lt[label][lang]}</div>
    {textNode}
  </div>
  )
}
